import section2Image from "../images/pic1.png";
import eventLogo from "../images/event-logo.png";
import progressBar from "../images/progress-bar.png";

function Section2() {
  const handleClick = () => {
    window.open(
      "https://donor.southtexasblood.org/donor/store/preview?utm_source=double_my_impact&utm_medium=landing_page&utm_campaign=twa_dontate&utm_content=stb&t",
      "_blan",
    );
  };
  return (
    <div className="bg-[#0a0a0ad8] text-white font-montserrat py-12 md:py-20 md:py-32">
      <div className="flex flex-col justify-center items-center gap-6 md:gap-8">
        <div className="max-w-[1100px] color-text text-center text-[32px] md:text-5xl xl:text-[82px] md:leading-[1.4] px-8 md:px-0">
          Help us Stuff the Bus with School Supplies
        </div>
        {/* <div className="font-montserrat max-w-4xl text-[#d6d6d6] text-center text-[22px] md:text-[26px]">
          Our goal is simple. Send as many kids who have recovered from or have
          cancer to camp for a fun-filled experience.
        </div> */}
        <div className="flex justify-center items-center">
          <img
            src={progressBar}
            alt="Progress bar"
            className="w-[330px] md:w-[630px] 2xl:w-[930px] h-auto object-contain"
          />
        </div>
        {/* <div className="font-medium text-[20px] md:text-[45px]">
          Our goal is to send 5 kids to camp
        </div> */}
        <div className="font-montserrat text-[#FEB725] text-[16px] md:text-[20px] xl:text-[24px] leading-[1.7] italic -mt-2 md:-mt-4">
          It takes $5,000 to fill the bus.
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row justify-center items-center gap-12 pt-16 md:pt-28 xl:pt-36">
        <div className="flex flex-col md:w-1/2 gap-8 md:gap-12 px-6 md:pl-[7%]">
          <img
            src={eventLogo}
            alt="Event Logo"
            className="block mx-auto md:mx-0 w-[280px] md:w-[360px] xl:w-[520px]"
          />
          {/* <div className="text-center md:text-left text-[39px] md:text-5xl xl:text-[72px] leading-[1.3]">
            How do I Donate?
          </div> */}
          <div className=" text-[#d6d6d6] text-center md:text-left text-[22px] md:text-[28px] leading-[1.7]">
            Back-to-school expenses can be difficult for many South Texas
            families. By donating some of your reward points, you help a
            deserving student get the school supplies they need.
          </div>
          <button
            className="donate-btn mx-auto md:mx-0 md:mt-4"
            onClick={handleClick}
          >
            Donate points
          </button>
        </div>
        <div className="flex justify-center items-center max-w-[75%] md:w-1/2 md:px-6">
          <img src={section2Image} alt="School Bus Kid" />
        </div>
      </div>
    </div>
  );
}

export default Section2;
